import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons/faPlusCircle";

import { Helmet } from "react-helmet";

import {
  HydraTable,
  Heading,
  TextFilter,
  StyledCheckbox,
} from "@peracto/peracto-ui";

import { GET_LIST, useClient } from "@peracto/client";

const CustomerGroupsList = () => {
  // Default visible columns - key = column accessor
  const [selectedColumns, onSelectColumn] = useState({});

  const { client } = useClient();

  // The 'selectable' property is used to define if the
  // column is available in the 'manage columns' dropdown
  const columns = [
    {
      id: "selection",
      Header: ({ getToggleAllRowsSelectedProps }) => (
        <StyledCheckbox {...getToggleAllRowsSelectedProps()} />
      ),
      Cell: ({ row }) => (
        <StyledCheckbox {...row.getToggleRowSelectedProps()} />
      ),
      selectable: false,
    },

    {
      Header: "Name",
      accessor: "name",
      sortType: "basic",
      Filter: (props) => <TextFilter label="Name" {...props} />,
      Cell: (row) => <Link to={row.row.original.id}>{row.cell.value}</Link>,
      selectable: false,
    },
  ];

  const onFetchData = (options) => client(GET_LIST, "customer-groups", options);

  return (
    <>
      <Helmet>
        <title>Customer Groups | Peracto</title>
      </Helmet>
      <Heading name="Customer Groups">
        <div className="ml-2 d-flex align-items-center">
          <Link className="btn btn-primary" to="/customer-groups/add">
            <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
            Add Customer Group
          </Link>
        </div>
      </Heading>

      <div className="row">
        <div className="col">
          <div className="card card--transparent">
            <div className="card-body">
              <HydraTable
                columns={columns}
                selectedColumns={selectedColumns}
                onFetchData={onFetchData}
                onSelectColumn={onSelectColumn}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerGroupsList;
